import HttpFactory from '~/repository/factory';

class AuthModule extends HttpFactory {
  private RESOURCE = '/auth';

  async me() {
    return await this.get(`${this.RESOURCE}/me`);
  }
}

export default AuthModule;
